module.exports = (
  $scope,
  $uibModal,
  $state,
  $stateParams,
  bulkupload,
  User,
  Api) ->
  $scope.user = User

  $scope.loadPage = (page) ->
    $state.go('bulkupload', {
      'page': page
    }, { reload: true })

  $scope.open_confirm_modal = (file, mappingId, mappingName) ->
    confirmModal = $uibModal.open
      template: require('./bulk-upload-modal-confirm.html')
      controller: 'BulkUploadModalConfirmController'
      resolve:
        file: () ->
          return file
        mappingId: () ->
          return mappingId
        mappingName: () ->
          return mappingName

    confirmModal.result.then () ->
      $scope.loadPage(1)

  $scope.open_upload_modal = ->
    if !$scope.user.has_bulk_upload_mapping
      return false

    uploadModal = $uibModal.open
      template: require('./file-upload-modal.html')
      controller: 'BulkUploadModalController'
      resolve:
        mappings: () ->
          return Api.BulkUploadMappings.get().$promise

    uploadModal.result.then (result) ->
      if (result?.file)
        $scope.open_confirm_modal(result.file, result.mappingId, result.mappingName)

  statusToClassName =
    'created': 'active'
    'processing': 'info'
    'completed': 'success'
    'failed': 'danger'

  $scope.getClassNameFromStatus = (status) ->
    statusToClassName[status] or ''

  $scope.bulkuploads = bulkupload.results
  $scope.currentPage = $stateParams.page
  $scope.totalBulkUploads = bulkupload.count
